package mapsearch

import apiclient.geoobjects.GeoObjectDetails
import data.users.UserListStore
import koin.withKoin
import mapsearch.buildings.BuildingLookUpStore
import mapsearch.generalMarkers.GeneralMarkerLookUpStore
import mapsearch.generalMarkers.GeneralMarkersSearchSpecStore
import mapsearch.globalsearch.toMapMarker
import mapsearch.websocket.MapMarkerSubscription
import mapsearch.zones.ZoneObjectLookUpStore
import mapsearch.zones.ZoneSearchSpecStore

fun insertInCaches(obj: GeoObjectDetails) {
//    console.log("^ INSERT IN CACHES:", obj.title, obj.latLon.toString())
    withKoin {
        val mapMarkerSubscription: MapMarkerSubscription = get()
        mapMarkerSubscription.handleNewObjects(listOf(obj))
    }
}

fun updateInCaches(obj: GeoObjectDetails) {
//    console.log("^ UPDATE IN CACHES:", obj.title, obj.latLon.toString())
    withKoin {
        val mapMarkerSubscription: MapMarkerSubscription = get()
        mapMarkerSubscription.handleObjectUpdates(listOf(obj.toMapMarker()))
    }
}

fun removeInCaches(obj: GeoObjectDetails) {
//    console.log("REMOVE IN CACHES:", obj.title, obj.latLon.toString())
    withKoin {
        val mapMarkerSubscription: MapMarkerSubscription = get()
        mapMarkerSubscription.handleObjectDeletions(listOf(obj))
    }
}

fun isBuilding(id: String): Boolean {
    withKoin {
        val buildingLookUpStore: BuildingLookUpStore = get()
        return id in buildingLookUpStore.current.keys
    }
}

fun isZone(id: String): Boolean {
    withKoin {
        val zoneObjectLookUpStore: ZoneObjectLookUpStore = get()
        return id in zoneObjectLookUpStore.current.keys
    }
}

fun isGeneralMarker(id: String): Boolean {
    withKoin {
        val generalMarkerLookUpStore: GeneralMarkerLookUpStore = get()
        return id in generalMarkerLookUpStore.current.keys
    }
}

fun isUser(id: String): Boolean {
    withKoin {
        val userListStore: UserListStore = get()
        return userListStore.getPublicUserProfile(id) != null
    }
}

fun isNotBuildingOrZoneOrGeneralMarker(id: String) = !isBuilding(id) && !isZone(id) && !isGeneralMarker(id)

fun setIncludedZones(ids: Set<String>?) {
    withKoin {
        val zoneSearchSpecStore: ZoneSearchSpecStore = get()
        zoneSearchSpecStore.includeZones(ids)
    }
}

fun setIncludedGeneralMarkers(ids: Set<String>?) {
    withKoin {
        val generalMarkersSearchSpecStore: GeneralMarkersSearchSpecStore = get()
        generalMarkersSearchSpecStore.includeGeneralMarkers(ids)
    }
}
